import { CogPauseOutlineIcon } from './CogPauseOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7BC10816-C8A9-4B8D-B11B-B51E0CCB9F72
 * name cog-pause-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-pause-outline.svg
 * tags
 * - Settings 
 */
export const GearPauseOutlineIcon = CogPauseOutlineIcon;
export default GearPauseOutlineIcon